import { gql } from "@apollo/client";

const ReconcileEdits = gql`
  mutation ReconcileEdits {
    reconcileEdits(input: {}) {
      boolean
    }
  }
`;

const hash = "f8e6e7ea3e51b15c92959438a37aa089ce600eb5ff204089764cbdd404871a98";

export { ReconcileEdits, hash };
